import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Constraints from "../screens/Constraints";
import ConstraintsList from "../screens/ConstraintsList";
import Coupon from "../screens/Coupon";
import Dashboard from "../screens/Dashboard";
import EditContent from "../screens/EditContent";
import Login from "../screens/Login";
import MainAttractionDetail from "../screens/MainAttractionDetail";
import Orders from "../screens/Orders";
import ShackClosing from "../screens/ShackClosing";
import { paths } from "./paths";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to={paths.login} />} />
        <Route exact path={paths.login} element={<Login />} />
        <Route exact path={paths.dash} element={<Dashboard />} />
        <Route exact path={paths.editContent} element={<EditContent />} />
        <Route exact path={paths.coupon} element={<Coupon />} />
        <Route
          exact
          path={paths.mainAttractionDetail(":id")}
          element={<MainAttractionDetail />}
        />
        <Route exact path={paths.constraints} element={<Constraints />} />
        <Route
          exact
          path={paths.constraintsList}
          element={<ConstraintsList />}
        />
        <Route exact path={paths.shackClosing} element={<ShackClosing />} />
        <Route exact path={paths.orders} element={<Orders />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
